import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Brain, Heart, Hand, Users, Sunrise } from 'lucide-react';
export function ContentSection() {
  const chapters = [{
    icon: <Heart className="w-8 h-8 text-coral" data-id="element-61" />,
    title: 'Verdadero Autocuidado:',
    desc: 'Estrategias reales para cuando la vida y la rutina se vuelven completamente abrumadoras.'
  }, {
    icon: <Brain className="w-8 h-8 text-coral" data-id="element-62" />,
    title: 'Control del Crítico Interior:',
    desc: 'Aprendé a silenciar y domar esa voz que te juzga, te autosabotea y te genera inseguridades.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-coral" data-id="element-63" />,
    title: 'Inteligencia Emocional Aplicada:',
    desc: 'Cómo gestionar e integrar todas las emociones, incluso aquellas que pretendés ignorar o esconder.'
  }, {
    icon: <Hand className="w-8 h-8 text-coral" data-id="element-64" />,
    title: 'El Arte de Decir «NO»:',
    desc: 'Herramientas prácticas para establecer límites saludables con tu familia, pareja y trabajo sin sentir culpa.'
  }, {
    icon: <Users className="w-8 h-8 text-coral" data-id="element-65" />,
    title: 'Encontrar a tu Tribu:',
    desc: 'Estrategias para mantener relaciones interpersonales saludables y construir una red de apoyo real.'
  }, {
    icon: <Sunrise className="w-8 h-8 text-coral" data-id="element-66" />,
    title: 'Superación del Duelo:',
    desc: 'Claves basadas en la ciencia para hacer frente al dolor de la pérdida y los cambios drásticos de la vida.'
  }];
  return <section className="py-12 md:py-16 bg-cream" data-id="element-67">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-69">
          <div className="inline-flex items-center justify-center gap-2 text-coral font-bold tracking-wider uppercase mb-4" data-id="element-70">
            <BookOpen className="w-6 h-6" data-id="element-71" />
            <span data-id="element-72">Contenido del libro</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-dark mb-6" data-id="element-73">
            LO QUE VAS A LOGRAR DENTRO DEL LIBRO:
          </h2>
          <p className="text-lg md:text-xl text-dark-light max-w-3xl mx-auto" data-id="element-74">
            La experimentada terapeuta Liz Kelly te acerca las herramientas de
            la consulta psicológica de forma clara, accesible y libre de
            tecnicismos aburridos:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-75">
          {chapters.map((chapter, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-sm border border-cream-dark hover:shadow-md transition-all hover:-translate-y-1" data-id="element-76">
              <div className="bg-coral/10 w-16 h-16 rounded-2xl flex items-center justify-center mb-6" data-id="element-77">
                {chapter.icon}
              </div>
              <h3 className="text-xl font-display font-bold text-dark mb-3" data-id="element-78">
                {chapter.title}
              </h3>
              <p className="text-dark-light leading-relaxed" data-id="element-79">{chapter.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}